module.exports = __webpack_public_path__ + "img/電気回路_1_6.d33cb8bd.png";